<template>
  <div class="squ-view">
    <div class="squ-item" v-for="item in blockList" :key="item.val">
      <div class="item-top">{{ blockNums[item.val] }}</div>
      <div class="item-bott">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["blockList", "blockNums"],
  data() {
    return {
      video: [
        { paramName: "我的视频数", val: "totalCount" },
        { paramName: "与我共享的视频数", val: "sharedCount" },
        { paramName: "上线视频数", val: "onlineCount" },
        { paramName: "下线视频数", val: "offCount" },
        { paramName: "长视频数", val: "longCount" },
        { paramName: "微课数", val: "microCount" },
      ],
      audio: [],
      book: [
        { name: "我的图书数", val: "totalCount" },
        { name: "与我共享的图书数", val: "sharedCount" },
        { name: "上线数", val: "onlineCount" },
        { name: "下线数", val: "offCount" },
      ],
      period: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.squ-view {
  display: flex;
  margin: 0 -8px;
  .squ-item {
    margin: 0 8px;
    flex: 1;
    height: 112px;
    text-align: center;
    background: #f5f7fc;
    &:hover {
      background: #ffffff;
      box-shadow: 0px 5px 11px 3px rgba(0, 0, 0, 0.05);
      border-radius: 6px;
    }
    .item-top {
      padding: 21px 0 5px 0;
      font-size: 32px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: #343c4a;
      line-height: 39px;
    }
    .item-bott {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #51627d;
      line-height: 17px;
    }
  }
}
</style>